import type { Column, FilterCondition, Row, StringColumn } from "./types";
import { Columns, StringColumns } from "./types";

export function deserializeFilters(param: string): FilterCondition[] {
  if (!param) return [];

  return param
    .split(",")
    .map((str): FilterCondition | undefined => {
      if (str.includes("=")) {
        const [column, value] = str.split("=");
        if ((StringColumns as readonly string[]).includes(column)) {
          return {
            type: "eq",
            column: column as StringColumn,
            value,
          };
        }
      } else if (str.includes("<")) {
        const [column, maxValue] = str.split("<");
        if ((Columns as readonly string[]).includes(column)) {
          return {
            type: "range",
            column: column as Column,
            maxValue: Number(maxValue),
          };
        }
      }
    })
    .filter((f): f is FilterCondition => f !== undefined);
}

export function serializeFilters(filterConditions: FilterCondition[]): string {
  return filterConditions
    .map((condition): string => {
      switch (condition.type) {
        case "eq":
          return `${condition.column}=${condition.value}`;
        case "range":
          return `${condition.column}<${condition.maxValue}`;
      }
    })
    .filter(Boolean)
    .join(",");
}

export function applyFilter(row: Row, condition: FilterCondition): boolean {
  const value = row[condition.column];

  switch (condition.type) {
    case "eq":
      return `${value}` === condition.value;
    case "range":
      return typeof value === "number" ? value <= condition.maxValue : true;
  }
}
